import UserForm from 'app/admin/users/components/UserForm'
import { createUser } from '../reducers/actions'
import {
	getPeerRoleOptions,
	getError,
	getIsFetching,
} from '../reducers/selectors'
import useFetchData from 'app/_common/hooks/useFetchData'
import { fetchRoles } from 'app/admin/roles/reducers/actions'
import useUISelectors from 'app/_common/hooks/useUISelectors'

const NewUser = () => {
	const roleOptions = useFetchData(fetchRoles, getPeerRoleOptions)
	const ui = useUISelectors(getError, getIsFetching)

	return (
		<UserForm
			submitAction={createUser}
			title='New user'
			roleOptions={roleOptions}
			{...ui}
		/>
	)
}

export default NewUser
